import React, { useState, useEffect, useCallback } from 'react';
import { RotateCcw } from 'lucide-react';
import { getContableAcounts, clearContableAccountsCache } from '../../../usecases/contable-acounts-usecase';
import SearchDropdown from '../../atoms/searchdropdown/view';
import './style.css';

const AccountSearchDropdown = ({ onSelected, selected = undefined, accounts = null }) => {
    const [allAccounts, setAllAccounts] = useState([]);
    const [loading, setLoading] = useState(!accounts); // Only loading if accounts prop is not provided
    const [error, setError] = useState(null);

    const formatAccounts = (data) => {
        return (data || []).map(item => ({
            ...item,
            name: `${item.account} - ${item.description}`
        }));
    };

    const fetchAccounts = useCallback(async () => {
        if (accounts) {
            setAllAccounts(formatAccounts(accounts));
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            const response = await getContableAcounts(1, 2200, [{ label: "level", value: "3" }]);
            setAllAccounts(formatAccounts(response.data));
            setError(null);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, [accounts]);

    useEffect(() => {
        fetchAccounts();
    }, [fetchAccounts]);

    const handleReload = () => {
        if (!accounts) {
            clearContableAccountsCache();
            fetchAccounts();
        }
    };

    if (loading) {
        return <div className="account-search-dropdown-loading">Cargando cuentas...</div>;
    }

    return (
        <div className="account-search-container">
            <SearchDropdown
                placeholder={
                    selected ?
                        allAccounts.find(itm => itm.id === selected?.id)?.name
                        : 'Selecciona una cuenta'
                }
                options={allAccounts}
                path='name'
                onSelect={onSelected}
                forceReload={handleReload}
            />
            {error && <div className="error-text">Error: {error.message}</div>}
        </div>
    );
};

export default AccountSearchDropdown;
